export default "__VITE_ASSET__Dm3B7W4m__"